var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isAllowedToAccessSalesforceDashboard)?[_c('SalesforceDashboard'),_c('SalesforceShopRequests')]:_vm._e(),_c('internet-shop-table'),_c('phone-shop-table'),_c('group-shop',{staticClass:"mt-5"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }